module.exports = __webpack_public_path__ + "img/checked-sign.c6bed524.svg";